<template>
  <div>
    <p>{{ $t('ui.envelopes.create.steps.parties.passwordTab.info') }}</p>

    <div class="flex gap-base">
      <div class="flex flex-col gap-base">
        <FloatingLabelInput
          :value="value"
          @input="$emit('input', $event)"
          @blur="$emit('blur', $event)"
          :hasError="!!errors && !!errors.length"
          placeholder="Password"
          class="mb-0"
          data-ec="envelope_create_add_recipients_password_tab"
          data-et="password_input"
        />

        <ValidationError
          :hasError="!!errors && !!errors.length"
          :errorMessage="errors && errors[0]"
        >
          <template
            v-if="errors && errors[0] === 'PasswordRequired'"
            v-slot:content
          >
            <p class="text-14 font-bold mb-0">
              {{ $t('ui.envelopes.create.steps.parties.passwordTab.required') }}
            </p>
            <p class="text-14">
              {{ $t('ui.envelopes.create.steps.parties.passwordTab.advice') }}
              <span
                class="underline cursor-pointer"
                @click="$emit('remove')"
              >
                {{
                  $t('ui.envelopes.create.steps.parties.passwordTab.adviceLink')
                }}
              </span>
            </p>
          </template>
        </ValidationError>
      </div>

      <div
        class="flex"
        :class="{ 'pt-sixteen items-start': !!errors && !!errors.length }"
      >
        <CopyToClipboardControl
          :target="value"
          data-ec="create_envelope_add_party_password"
          data-et="copy_password_to_clipboard_button"
        />
      </div>
    </div>
  </div>
</template>

<script>
// @ts-check
import { defineComponent } from 'vue';

import ValidationError from '@/components/library/error/ValidationError';
import FloatingLabelInput from '@/components/tailwind/forms/FloatingLabelInput.vue';
import { CopyToClipboardControl } from '@/components/ui/envelopeCreate/steps/addRecipients/passwordTab/CopyToClipboardControl';

export default defineComponent({
  components: {
    ValidationError,
    FloatingLabelInput,
    CopyToClipboardControl,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    /** @type {import('vue').PropOptions<string[]>} */
    errors: {
      type: Array,
    },
  },
});
</script>
